// extracted by mini-css-extract-plugin
module.exports = {"pagination":"Table_pagination__FKbtv","row":"Table_row__2NCmO","rowSelected":"Table_rowSelected__ei2Sv"};